import type { User } from "../../lib/auth-store";

/** Immagine del profilo dell'utente, o le iniziali se non l'ha caricata
 * (Andrea 2026-09-29). */
export function AvatarUtente({
  user,
  size = 36,
  className = "",
}: {
  user: Pick<User, "nome_completo" | "avatar_data_url"> | null | undefined;
  size?: number;
  className?: string;
}) {
  const nome = user?.nome_completo?.trim() ?? "";
  const iniziali =
    nome
      .split(/\s+/)
      .slice(0, 2)
      .map((p) => p.charAt(0).toUpperCase())
      .join("") || "?";
  const stile = { width: size, height: size };
  if (user?.avatar_data_url) {
    return (
      <img
        src={user.avatar_data_url}
        alt={nome || "Profilo"}
        style={stile}
        className={`rounded-full object-cover border border-accent/40 shrink-0 ${className}`}
      />
    );
  }
  return (
    <span
      style={{ ...stile, fontSize: Math.max(10, Math.round(size * 0.38)) }}
      className={`rounded-full bg-primary text-accent font-bold flex items-center justify-center border border-accent/30 shrink-0 ${className}`}
      aria-hidden
    >
      {iniziali}
    </span>
  );
}
